import { render, staticRenderFns } from "./SystemCommunicationsEmail.vue?vue&type=template&id=fcecf06e&scoped=true"
import script from "./SystemCommunicationsEmail.vue?vue&type=script&lang=js"
export * from "./SystemCommunicationsEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcecf06e",
  null
  
)

export default component.exports